const productionHostnames = new Set(["stancekit.com", "www.stancekit.com"]);

export function isProductionSite(hostname = window.location.hostname) {
  return productionHostnames.has(hostname.toLowerCase().replace(/\.$/, ""));
}

export function isProductionPreview(search = window.location.search) {
  return (
    import.meta.env.DEV &&
    new URLSearchParams(search).get("preview") === "production"
  );
}
